import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { USER_AUTH, USER_VALIDATE } from "actions/user";
import { SET_AUTHENTICATING } from "actions/authenticatingUser";

const authenticatingUser = (state = initialState.authenticatingUser, action: any) => {
  switch (action.type) {
    case pending(USER_AUTH):
    case pending(USER_VALIDATE):
      return true;
    case fulfilled(USER_AUTH):
    case failed(USER_AUTH):
    case fulfilled(USER_VALIDATE):
    case failed(USER_VALIDATE):
      return false;

    case SET_AUTHENTICATING:
      return !!action.payload.authenticatingUser;

    default:
      return state;
  }
};

export default authenticatingUser;
